<template>
  <v-container v-if="item">
    <toolbar mode="report" :item="item" @delete="onDelete">
      <ax-button 
        icon="mdi-download"
        tooltip="Download Report"
        :disabled="item.status !== 'SUCCESS' || !item.file"
        @clicked="onDownload"
      />
    </toolbar>
    <v-card flat>
      <v-tabs v-model="tab">
        <template v-if="item.status == 'SUCCESS'">
          <v-tab href="#data">Data</v-tab>
          <v-tab href="#info">Info</v-tab>
        </template>
        <template v-else>
          <v-tab href="#result">Result</v-tab>
        </template>
        <v-tab href="#logs">Logs</v-tab>
        <v-tab href="#details">Details</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <template v-if="item.status == 'SUCCESS'">
          <v-tab-item value="data">
            <frame-head :items="head" @load="onLoad" />
          </v-tab-item>
          <v-tab-item value="info">
            <frame-info :items="info" />
          </v-tab-item>
        </template>
        <v-tab-item v-if="item.result" value="result">
          <v-card-text v-if="item.result">
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Task</v-col>
              <v-col>{{ item.result.task_name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Status</v-col>
              <v-col>{{ item.result.status }}</v-col>
            </v-row>
            <v-row dense v-if="item.result.status == 'FAILURE'">
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Result</v-col>
              <v-col>{{ JSON.parse(item.result.result)['exc_type'] }}: {{ JSON.parse(item.result.result)['exc_message'].join(', ') }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Completed</v-col>
              <v-col>{{ item.result.date_done | dateFormat("LL LT") }} ({{ item.result.date_done | dateFormat }})</v-col>
            </v-row>
            <v-row dense v-if="user.is_superuser">
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Traceback</v-col>
              <v-col><pre>{{ item.result.traceback }}</pre></v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <v-alert type="info" text>No task result available yet</v-alert>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="logs">
          <v-card-text>
            <pre>{{ item.logs || 'No logs available' }}</pre>
          </v-card-text>
        </v-tab-item>
        <v-tab-item value="details">
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Name</v-col>
              <v-col>{{ item.name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Prediction</v-col>
              <v-col>
                <router-link :to="{ name: 'predictionShow', params: { uuid: item.prediction.uuid }}">
                  {{ item.prediction.name }}
                </router-link>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Owner</v-col>
              <v-col>{{ item.owner.name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Created</v-col>
              <v-col>{{ item.created_at | dateFormat("LL LT") }} ({{ item.created_at | dateFormat }})</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="2" md="1" class="font-weight-bold">Updated</v-col>
              <v-col>{{ item.updated_at | dateFormat("LL LT") }} ({{ item.updated_at | dateFormat }})</v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import AxButton from "@/components/button"
import AxStatus from "@/components/status"
import toolbar from "@/components/toolbar"
import frameHead from "@/components/head"
import frameInfo from "@/components/info"
import Reports from "@/api/reports"
export default {
  name: "Report",
  components: {
    toolbar,
    AxButton,
    AxStatus,
    frameHead,
    frameInfo
  },
  data() {
    return {
      item: null,
      head: {
        data: [],
        schema: {}
      },
      info: {
        data: [],
        schema: {}
      },
      headLoaded: false,
      headLoading: false
    }
  },
  created() {
    Reports.retrieve(this.$route.params.uuid).then(response => {
      this.item = response.data
      // Load headers and info if report is successful
      if (this.item.status === 'SUCCESS' && this.item.file) {
        this.headLoading = true
        Reports.headers(this.$route.params.uuid).then(headResponse => {
          this.head = typeof headResponse.data == "string" ? JSON.parse(headResponse.data) : headResponse.data
          // Check if we loaded less than a full page (50 rows default)
          if (!this.head.data || this.head.data.length < 50) {
            this.headLoaded = true
          }
        }).finally(() => {
          this.headLoading = false
        })
        
        Reports.info(this.$route.params.uuid).then(infoResponse => {
          this.info = typeof infoResponse.data == "string" ? JSON.parse(infoResponse.data) : infoResponse.data
        })
      }
    })
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ hash: tab })
      },
      get () {
        return this.$route.hash.replace('#', '')
      }
    },
  },
  methods: {
    onLoad() {
      // Don't load if all data is already loaded or currently loading
      if (this.headLoaded || this.headLoading) {
        return
      }
      
      this.headLoading = true
      Reports.headers(this.$route.params.uuid, this.head.data.length)
        .then((response) => {
          let head = typeof response.data == "string" ? JSON.parse(response.data) : response.data
          if (head.data && head.data.length > 0) {
            if (this.head.data.length === 0) {
              this.$set(this.head, 'data', head.data)
            } else {
              this.head.data.push(...head.data)
            }
            if (head.schema && Object.keys(head.schema).length > 0) {
              this.$set(this.head, 'schema', head.schema)
            }
            // Mark as loaded if we received less than a full page
            if (head.data.length < 50) {
              this.headLoaded = true
            }
          } else {
            // No more data available
            this.headLoaded = true
          }
        })
        .finally(() => {
          this.headLoading = false
        })
    },
    onDownload() {
      this.setBusy(true)
      Reports.download(this.$route.params.uuid).then(response => {
        // Create download link for Excel file
        var downloadLink = document.createElement("a")
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        })
        var url = URL.createObjectURL(blob)
        downloadLink.href = url
        downloadLink.download = `${this.item.name}.xlsx`.replace(/ /g, '_')
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        URL.revokeObjectURL(url)
      }).catch(_ => {
        this.notify('Failed to download report', 'error')
      }).finally(() => this.setBusy(false))
    },
    onDelete() {
      Reports.destroy(this.$route.params.uuid).then(_ => {
        this.notify('Report deleted')
        this.$router.push({ name: 'reportList' })
      }).catch(_ => {
        this.notify('Failed to delete report', 'error')
      })
    }
  }
}
</script>
